// BlockTypeSelector > BlockTypeSelector
import React, { ChangeEvent } from 'react'
import Radio from '../Radio'
import Checkbox from '../Checkbox'
import styles from './BlockTypeSelector.module.css'
import { BlockTypeSelectorProps } from './index'
import { blockTypeSelectorDefaultProps } from './IBlockTypeSelector'
import FlexBox from '../FlexBox'
import { IBlockType } from '../BlockType/IBlockType'

export default class BlockTypeSelector<BlockTypesType> extends React.PureComponent<
	BlockTypeSelectorProps<BlockTypesType>
> {
	static readonly defaultProps = blockTypeSelectorDefaultProps
	private readonly _component: React.ReactType = this.props.multiSelect ? Checkbox : Radio

	componentDidMount() {
		const { withManagement, AddBlockTypeComponent, removeBlockType } = this.props

		if (withManagement) {
			if (!AddBlockTypeComponent) {
				console.warn('react-calendar-grid: Attempting to manage block types without AddBlockTypeComponent prop')
			}

			if (!removeBlockType)
				console.warn('react-calendar-grid: Attempting to manage block types without removeBlockType prop')
		}
	}

	private _handleSelect = (arg?: ChangeEvent<HTMLInputElement> | string | string[]) => {
		const { onSelect } = this.props
		let value: string = ''

		if (arg) {
			value =
				typeof arg === 'object' && !Array.isArray(arg)
					? (arg.target as HTMLInputElement).value
					: Array.isArray(arg)
						? arg.join('') // if it came in as a string array it needs to be made into a string for parseInt to work
						: arg
		}

		onSelect(value)
	}

	private _handleRootClick = (value?: string | string[]) => this._handleSelect(value)

	private _handleChange = (event: ChangeEvent<HTMLInputElement>) => this._handleSelect(event)

	private _handleRemove = (event: React.MouseEvent<HTMLButtonElement>, type: IBlockType<BlockTypesType>) => {
		event.preventDefault()
		const { removeBlockType } = this.props

		if (removeBlockType) removeBlockType(type.resource)
	}

	render() {
		const { selected, blockTypes, disabled, withManagement, AddBlockTypeComponent, removeBlockType } = this.props
		const Component = this._component

		return (
			<div className={styles.root}>
				{withManagement && AddBlockTypeComponent && <AddBlockTypeComponent />}
				{blockTypes.map((type, ix) => {
					const checked = selected.includes(ix.toString())

					return (
						<FlexBox key={type.label || ix} container>
							<Component
								disabled={disabled || (selected.length === 1 && checked)}
								name={type.label}
								value={ix.toString()}
								handleRootClick={this._handleRootClick}
								onChange={this._handleChange}
								checked={checked}
							/>
							{withManagement &&
								removeBlockType && (
									<button onClick={event => this._handleRemove(event, type)}>X</button>
								)}
						</FlexBox>
					)
				})}
			</div>
		)
	}
}
